import React from 'react'
import ReactDOM from 'react-dom'
import UserBanner from '../../../site/layout/component/UserBanner'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'

const debug = require('debug')('user banner')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-user-banner').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <UserBanner {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
